import { render, staticRenderFns } from "./DettaglioChiamateOperatore.vue?vue&type=template&id=0b42d71c&"
import script from "./DettaglioChiamateOperatore.vue?vue&type=script&lang=ts&"
export * from "./DettaglioChiamateOperatore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports